export default __webpack_public_path__ + "static/Crisp-bbbd9b7d35751eb62b680e421689c0dd.png";